import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./../../../pages/EVs/EVs.scss";
import NewUsedEVFilter from "../../components/NewUsedEVFilter/NewUsedEVFilter";
import EVCatalog from "../../components/EVCatalog/EVCatalog";
import MatchScoreOptions from "../../components/MatchScoreOptions/MatchScoreOptions";
import EvSortControls from "./../../../components/EvSortControls/EvSortControls";

import EVFilterControls from "../../components/EVFilterControls/EVFilterControls";
import ModalComponent from "../../../components/ModalUIComponent/ModalUIComponent";

import { FormattedMessage, useIntl } from "react-intl";

const EVs = ({ electricVehicles, ip, uuid, isCanada }) => {
     const intl = useIntl();
     const uberIncentiveUrl = isCanada
          ? "https://www.uber.com/ca/en/drive/services/electric/zero-emissions-incentive/"
          : "https://www.uber.com/us/en/drive/services/electric/zero-emissions-incentive/?uclick_id=d5b71aa2-e129-46e3-b3d9-36f4df84dc87";

     useEffect(() => {
          document.title = process.env.REACT_APP_PAGES_VEHICLES_TITLE;
     });

     const time = new Date().toLocaleString();
     const size = window.innerWidth > 600;
     const renderOptions = (
          <>
               {size ? (
                    <div style={{ display: "inline" }}>
                         <NewUsedEVFilter value={"new"} />
                    </div>
               ) : null}
               <MatchScoreOptions />
               <br />
               <EVFilterControls vehicles={electricVehicles} />
          </>
     );

     return (
          <section className="container" id="EVs">
               <div className="row mb-3">
                    <div className="col-sm-12 text-center">
                         <h1 className="page-title h2">
                              <FormattedMessage
                                   id="header.newVehicles"
                                   defaultMessage="Electric Vehicles"
                                   description="Electric Vehicles"
                              />
                         </h1>
                         <p className="lead">
                              <FormattedMessage
                                   id="evs.welcomeSub"
                                   defaultMessage="Compare electric cars by EV range, price, or your personalized Match Score. Click on the EV for more details, including total cost compared to a similar gas vehicle."
                                   description="Description of Colton Recharged"
                              />
                         </p>
                         <p className="competition-lead">
                              <FormattedMessage
                                   id="evs.competition.details"
                                   defaultMessage="Learn more about Uber's Go Electric Incentive {electricIncentiveLink}"
                                   description="Description of Colton Recharged"
                                   values={{
                                        lineBreak: <br />,
                                        electricIncentiveLink: (
                                             <a
                                                  href={uberIncentiveUrl}
                                                  className="competition-link"
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                             >
                                                  <FormattedMessage
                                                       id="evs.uberIncentive"
                                                       defaultMessage="HERE"
                                                       description=" Uber's Zero Emissions incentive"
                                                  />
                                             </a>
                                        )
                                   }}
                              />
                         </p>
                    </div>
               </div>
               <div className="row">
                    <div className="col">
                         {size ? null : (
                              <div style={{ display: "inline" }}>
                                   <NewUsedEVFilter value={"new"} />
                              </div>
                         )}
                         <div className="pull-right">
                              <EvSortControls />
                         </div>
                    </div>
               </div>
               <div className="row">
                    <div className="col-sm-12 d-block d-lg-none text-center">
                         <ModalComponent
                              buttonText={
                                   intl.formatMessage
                                        ? intl.formatMessage({
                                               id: "evs.buttonMatchScoreAndFilters",
                                               defaultMessage: "Match Score and Filters"
                                          })
                                        : "Match Score and Filters"
                              }
                              titleText={
                                   intl.formatMessage
                                        ? intl.formatMessage({
                                               id: "evs.matchScoreAndFilters",
                                               defaultMessage: "Refine Match Score and Filters"
                                          })
                                        : "Refine Match Score and Filters"
                              }
                         >
                              {renderOptions}
                         </ModalComponent>
                         <br />
                    </div>
                    <div className="col-xl-3 col-lg-4 d-none d-lg-block">{renderOptions}</div>
                    <div
                         id="electric-vehicles-catalog"
                         aria-live="polite"
                         aria-atomic="true"
                         role="region"
                         style={{ position: "absolute", top: "-9999px" }}
                    >
                         <span>
                              <FormattedMessage
                                   id="results.updated"
                                   defaultMessage="Results have been updated as of "
                                   description="Results have been updated as of "
                              />
                              {time}.
                         </span>
                    </div>
                    <div className="col-xl-9 col-lg-8 col-sm-12" style={{ paddingLeft: 10 }}>
                         <EVCatalog vehicles={electricVehicles} hasEvDetails hasIncentivesAndMatchScore />
                    </div>
               </div>
          </section>
     );
};

export default EVs;

EVs.propTypes = {
     electricVehicles: PropTypes.array,
     ip: PropTypes.string,
     uuid: PropTypes.string
};
